import { render, staticRenderFns } from "./ReportPeople.vue?vue&type=template&id=1acba769&"
import script from "./ReportPeople.vue?vue&type=script&lang=js&"
export * from "./ReportPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports